<template>
  <div>
    <Layout></Layout>
  </div>
</template>

<script>
  export default {
    components: {
      Layout: () => import('./components/pdd/Layout.vue'),
    },
  };
</script>
